import { Splide } from "@splidejs/splide";

document.addEventListener("DOMContentLoaded", function() {
    const productsSlider = document.querySelectorAll(
        ".splide-section_products-slider"
    );

    productsSlider.forEach(slider => {
        const type = slider.classList.contains("loop") ? "loop" : "slide";
        const productsSlider = new Splide(slider, {
            type: type,
            gap: "1rem",
            rewind: true,
            arrows: type === "loop",
            pagination: false,
            perPage: 4,
            perMove: 1,
            breakpoints: {
                768: {
                    perPage: 2,
                    perMove: 1
                },
                1024: {
                    perPage: 2,
                    perMove: 1
                }
            }
        });

        let bar = productsSlider.root.querySelector(
            ".products-slider__progress-bar"
        );

        // Updates the bar width whenever the carousel moves:
        productsSlider.on("mounted move", function() {
            var end = productsSlider.Components.Controller.getEnd() + 1;
            var rate = Math.min((productsSlider.index + 1) / end, 1);
            bar.style.width = String(100 * rate) + "%";
        });

        productsSlider.mount();
    });
});
